import React from 'react';
import moment from 'moment';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  selectedServiceInfo: any;
}

const SpecificServiceDetails = (props: IProps) => {
  const { selectedServiceInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      {/* Food Name*/}
      <div className="flex justify-between items-center">
        <div className="flex gap-8">
          <label className="text-xs md:text-sm text-white font-bold">Food Name</label>
          <label className="text-xs md:text-sm text-white font-normal">
            {selectedServiceInfo.foodName || '-'}
          </label>
        </div>
      </div>

      {/* Raised On */}
      <div className="flex gap-8">
        <label className="text-xs md:text-sm text-white font-bold">Ordered on</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {selectedServiceInfo.orderCreatedAt
            ? formatDateAndTime(selectedServiceInfo.orderCreatedAt)
            : '-'}
        </label>
      </div>

      {/* Food Category */}
      <div className="flex gap-[45px]">
        <label className="text-xs md:text-sm text-white font-bold">Category</label>
        <label className="text-xs md:text-sm text-white font-normal ml-1">
          {selectedServiceInfo.foodCategory || '-'}
        </label>
      </div>

      {/* Order Quantity */}
      <div className="flex gap-[50px]">
        <label className="text-xs md:text-sm text-white font-bold">Quantity</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {selectedServiceInfo.orderQuantity || '-'}
        </label>
      </div>

      {/* Order Quantity */}
      <div className="flex gap-16">
        <label className="text-xs md:text-sm text-white font-bold">Price</label>
        <label className="text-xs md:text-sm text-white font-normal ml-3">
        {selectedServiceInfo.currency || ''} {selectedServiceInfo.price || '-'}
        </label>
      </div>

      {/* Message */}
      <div className="flex gap-8">
        <label className="text-xs md:text-sm text-white font-bold">Description</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {selectedServiceInfo.description || '-'}
        </label>
      </div>
    </div>
  );
};

export default SpecificServiceDetails;
